// Module
var code = "<script>let $ctrl</script> <span class=\"atom-text-chip\" ng-if=\"$ctrl.isActive\"> <span>{{ $ctrl.content }}</span> <fa-icon ng-if=\"$ctrl.isRemovable\" class=\"atom-text-chip__close-icon link-icon space-left\" icon=\"times\" ng-click=\"$ctrl.deactivate()\"></fa-icon> </span> ";
// Exports
module.exports = code;